import type {
  ProductCatalogOffer,
  ProductCatalogVariant,
} from 'modules/it_management/lib/productCatalogGraphql'

import type { DeviceOffer, DeviceRecommendation } from './types'

const offerTypeMap: Record<string, DeviceOffer['type'] | undefined> = {
  onetime: 'onetime',
  renting: 'renting',
  credit: 'credit',
}

function toDeviceOffer(o: ProductCatalogOffer): [DeviceOffer] | [] {
  const type = offerTypeMap[o.type]
  if (!type) return []
  return [{ id: o.id, type, cost: o.cost, currency: o.currency, period: o.period }]
}

export function mapVariantToRecommendation(variant: ProductCatalogVariant): DeviceRecommendation {
  const productName = variant.product?.name || variant.sku || variant.id
  const variantDesc = variant.description?.trim()
  const productDesc = variant.product?.description?.trim()
  const description = variantDesc || productDesc || ''
  const title = productName

  return {
    id: variant.id,
    title,
    description,
    imageUrl: variant.firstProductMediaImageUrl ?? '',
    product: {
      brand: variant.product?.brand ?? '',
      name: variant.product?.name ?? '',
      typeName: variant.product?.typeName ?? '',
      sku: variant.sku ?? '',
      upc: variant.upc ?? null,
    },
    pricing: {
      amount: variant.firstOfferCost,
      currency: variant.offers[0]?.currency ?? 'EUR',
      period: variant.firstOfferPeriod ?? null,
      offers: variant.offers.flatMap(toDeviceOffer),
      taxes: variant.productTaxes.map((t) => ({
        name: t.taxName,
        value: t.taxValue,
      })),
    },
    availability: {
      stock: variant.stock ?? 0,
      deliveryConditions: variant.deliveryConditions ?? '',
    },
    attributes: variant.productAttributes.map((a) => ({
      id: a.id,
      name: a.name,
      value: a.value,
    })),
  }
}
